import React, { useEffect, useState } from "react";
import { faBuilding, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { spaceTypeImg } from "../../Constants/Images";
import { Button } from "react-bootstrap";
import CustomButton from "../../Components/Button";
import { updateUserAction } from "../../Services/Store/Actions/AuthActions";
import { useDispatch } from "react-redux";
import { showToast } from "../../utils/helpers";

interface IntroUserInterface {
  changeNextStep: Function;
  updateUserTypes: Function;
  skipStep: Function;
}

const IntroUserType: React.FC<IntroUserInterface> = ({
  changeNextStep,
  updateUserTypes,
  skipStep,
}) => {
  const dispatch = useDispatch();
  const [userTypes, setUserTypes] = useState<Array<string>>([]);

  const [loading, setLoading] = useState(false);

  const [eventActiveClass, setEventClass] = useState("");
  const [ownerActiveClass, setOwnerClass] = useState("");

  const updateUserType = (type: string) => {
    let tempTypes = [...userTypes];

    if (!tempTypes.includes(type)) {
      tempTypes.push(type);
    } else {
      tempTypes = tempTypes.filter((item) => item !== type);
    }

    updateUserTypes(tempTypes);
    setUserTypes(tempTypes);
  };

  const saveUserTypes = () => {
    if (userTypes.length === 0) {
      showToast(
        "error",
        "Please choose wether you are a venue owner or event planner"
      );
    } else {
      changeNextStep();

      // if (!loading) {
      //   setLoading(true);
      //   updateUserAction({ types: userTypes }, dispatch)
      //     .then((res) => {
      //       if (res.type === "success") {
      //         //changeStep("aboutVanue");
      //       }
      //     })
      //     .catch((err) => {
      //       //
      //       console.log("Err :", err);
      //     })
      //     .finally(() => {
      //       setLoading(false);
      //     });
      // }
    }
  };

  useEffect(() => {
    setEventClass(userTypes.includes("Event Planner") ? "active" : "");
    setOwnerClass(userTypes.includes("Venue Owner") ? "active" : "");
  }, [userTypes]);

  return (
    <>
      <div className="row intro-step">
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="intro-step-img">
            <img src={spaceTypeImg} alt="" />
          </div>
        </div>

        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="add-space-form-intro">
            <h2>
              Before we get started are you a venue owner or event planner?
            </h2>
            <p>
              Choose the type of account that best fits your role to begin your
              journey with us.
            </p>
          </div>

          <div className="add-space-types-options">
            <div
              className={`add-space-types-option-item as-link ${eventActiveClass}`}
              onClick={() => updateUserType("Event Planner")}
            >
              <span className="icon">
                <FontAwesomeIcon icon={faUser} />
              </span>
              Event Planner
            </div>

            <div
              className={`add-space-types-option-item as-link ${ownerActiveClass}`}
              onClick={() => updateUserType("Venue Owner")}
            >
              <span className="icon">
                <FontAwesomeIcon icon={faBuilding} />
              </span>
              Venue Owner
            </div>
          </div>
        </div>
      </div>

      <div className="navigation-btns">
        <Button className="skip-btn" onClick={() => skipStep()}>
          Skip
        </Button>

        <CustomButton
          isLoading={loading}
          title="Continue"
          onClick={() => saveUserTypes()}
        />
      </div>
    </>
  );
};

export default IntroUserType;
